module.exports = __webpack_public_path__ + "img/ymp_pdf_logo.d6184b7e.png";